<template>
  <div class="xcard">
    <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn
    >
    <template>
      <v-data-table :headers="headers" :items="desserts" :loading="loading" sort-by="calories" class="elevation-1">
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title> Cafc's </v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-btn class="green darken-2 white--text" @click="editItem()">
              <v-icon small class="mr-2">
                mdi-pencil
              </v-icon>
              Agregar
            </v-btn>
          </v-toolbar>
        </template>
        <template v-slot:[`item.opciones`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon class="mr-1" color="red" small v-bind="attrs" v-on="on" @click="editItem(item)">
                mdi-pencil
              </v-icon>
            </template>
            <span> Actualizar </span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                :disabled="item.estado == 0"
                class="mr-1"
                color="red"
                small
                v-bind="attrs"
                v-on="on"
                @click="preeliminar(item)"
              >
                mdi-bomb
              </v-icon>
            </template>
            <span> Finalizar Cafc </span>
          </v-tooltip>
        </template>
      </v-data-table>
    </template>

    <CafcRegistro ref="cafcregistro" v-on:newcafcregistro="newcafcregistro" />
  </div>
</template>

<script>
  import CafcRegistro from '@/views/recibos/cafc/registro.vue';
  import xaxios from '@/xaxios';
  export default {
    data: () => ({
      dialog: false,
      loading: false,
      headers: [
        { text: 'descripcion', value: 'descripcion' },
        { text: 'Codigo', value: 'codigo' },
        { text: 'Codigo Documento Sector', value: 'codigoDocumentoSector', width: 120 },
        { text: 'Factura Numero Inicio', value: 'facturaNumeroInicio', width: 100 },
        { text: 'Factura Numero Fin', value: 'facturaNumeroFin', width: 100 },
        { text: 'Estado', value: 'estado', width: 50 },
        { text: 'Fecha', value: 'fecha' },
        { text: 'Opciones', value: 'opciones', sortable: false },
      ],
      desserts: [],
    }),

    components: { CafcRegistro },

    computed: {},

    watch: {
      dialog(val) {
        val || this.close();
      },
    },

    created() {
      this.initialize();
    },

    methods: {
      initialize() {
        let vue = this;
        vue.loading = true;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/cafcs`,
          headers: {
            apikey: this.$store.getters.getApiKey,
          },
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data;
            data.reverse();
            window.console.log('eventos:', data);
            vue.desserts = data;
            vue.loading = false;
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loading = false;
          });
      },

      editItem(item) {
        this.$refs.cafcregistro.openmodal(item);
      },
      preeliminar(item) {
        window.console.log(item);
        let vue = this;
        let opt = {
          verification: 'finalizar',
          verificationHelp: 'Escriba "[+:verification]" para finalizar cafc.',
          okText: 'Finalizar',
          cancelText: 'cancelar',
          backdropClose: false,
          animation: 'bounce',
          loader: true,
          type: 'hard',
        };
        var message = {
          title: 'Confirmar fin',
          body: '<br> <b>NOTA:</b> Esta accion es irreversible.',
        };
        this.$dialog
          .confirm(message, opt)
          .then(function(dialog) {
            vue.finalizarItem(item, dialog);
          })
          .catch(function() {});
      },
      finalizarItem(item, dialog) {
        window.console.log(item);
        let vue = this;
        var config = {
          method: 'put',
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/cafcs/cerrar/${item.id}`,
          headers: {
            'Content-Type': 'application/json',
            apikey: this.$store.getters.getApiKey,
          },
          data: {},
        };

        xaxios.request(config)
          .then(function(response) {
            window.console.log(response);
            vue.initialize();
            dialog.close();
          })
          .catch(function(error) {
            window.console.log(error);
            dialog.close();
          });
      },
      newcafcregistro() {
        this.initialize();
      },
    },
  };
</script>
